import "./section-cl-product-info.js";
class n extends HTMLElement {
    #s = [];
    #e = null;
    connectedCallback() {
        this.#s = Array.from(this.querySelectorAll(".cl-sx__panel")), this.#e = this.querySelector(".cl-sx__list"), this.addEventListener("click", t => {
            const e = t.target;
            if (!(e instanceof Element)) return;
            const i = e.closest(".cl-sx__select");
            if (i) {
                this.#i(i);
                return
            }
            const s = e.closest(".cl-sx__list li");
            s && (this.select(Number(s.dataset.index)), this.#t(), this.querySelector(".cl-sx__panel.is-active .cl-sx__select")?.focus())
        }), this.addEventListener("keydown", t => {
            const e = this.#e;
            if (!e) return;
            const i = t.target instanceof Element ? t.target.closest(".cl-sx__select") : null;
            if (e.hidden) {
                i && (t.key === "ArrowDown" || t.key === "ArrowUp") && (t.preventDefault(), this.#i(i));
                return
            }
            const s = Array.from(e.children).filter(c => c instanceof HTMLElement && c.getAttribute("aria-selected") !== "true"),
                l = s.findIndex(c => c === document.activeElement);
            t.key === "Escape" ? (this.#t(), this.querySelector(".cl-sx__panel.is-active .cl-sx__select")?.focus()) : t.key === "ArrowDown" ? (t.preventDefault(), s[Math.min(l + 1, s.length - 1)]?.focus()) : t.key === "ArrowUp" ? (t.preventDefault(), s[Math.max(l - 1, 0)]?.focus()) : t.key === "Home" || t.key === "End" ? (t.preventDefault(), s[t.key === "Home" ? 0 : s.length - 1]?.focus()) : t.key === "Enter" || t.key === " " ? (t.preventDefault(), document.activeElement instanceof HTMLElement && document.activeElement.click()) : t.key === "Tab" && this.#t()
        }), this.addEventListener("focusout", t => {
            const e = t.relatedTarget;
            e instanceof Node && this.contains(e) || this.#t()
        }), document.addEventListener("click", t => {
            t.target instanceof Node && !this.contains(t.target) && this.#t()
        }), document.addEventListener("shopify:block:select", t => {
            const e = t.target;
            if (!(e instanceof Element)) return;
            const i = e.closest(".cl-sx__panel");
            i && this.contains(i) && this.select(Number(i.dataset.index))
        })
    }
    select(t) {
        this.#s.forEach(l => l.classList.toggle("is-active", Number(l.dataset.index) === t)), this.#e?.querySelectorAll("li").forEach(l => {
            l.setAttribute("aria-selected", String(Number(l.dataset.index) === t))
        }), this.dataset.active = String(t);
        const e = this.#s[t]?.querySelector(".cl-sx__select-value")?.textContent?.trim() ?? "",
            i = this.querySelector("[data-style-status]");
        i && (i.textContent = "", window.setTimeout(() => {
            i.textContent = (this.dataset.statusTemplate ?? "%style%").replace("%style%", e)
        }, 50));
        const s = {
            handle: this.#s[t]?.dataset.handle ?? ""
        };
        this.dispatchEvent(new CustomEvent("cl:style:change", {
            bubbles: !0,
            detail: s
        }))
    }
    #i(t) {
        const e = this.#e;
        if (!e) return;
        if (!e.hidden) {
            this.#t();
            return
        }
        const s = (t.closest(".cl-sx__select-card") ?? t).getBoundingClientRect(),
            l = this.getBoundingClientRect();
        const overlap = window.matchMedia("(width < 60rem)").matches ? 0 : 20;
        e.style.top = `${s.bottom-l.top-overlap}px`, e.style.left = `${s.left-l.left}px`, e.style.width = `${s.width}px`, e.hidden = !1, t.setAttribute("aria-expanded", "true"), e.querySelector('[aria-selected="false"]')?.focus({ preventScroll: true })
    }
    #t() {
        const t = this.#e;
        !t || t.hidden || (t.hidden = !0, this.querySelectorAll(".cl-sx__select").forEach(e => e.setAttribute("aria-expanded", "false")))
    }
}
customElements.get("cl-sock-explorer") || customElements.define("cl-sock-explorer", n);
